import React from "react";
import ResumeTitle from "./ResumeTitle";
import { MdWork } from "react-icons/md";
import { GiGraduateCap } from "react-icons/gi";
import ResumeCard from "./ResumeCard";

const Education = () => {
  return (
    <div className="w-full grid grid-cols-9 px-6">
      <div className="col-span-9 md:col-span-4">
        <ResumeTitle title="Experience" icon={<MdWork />} />
        <ResumeCard
          badge=""
          title="Freelance"
          subTitle="MYB4Y"
          des="I started my own company to leverage my expertise in helping other businesses."
        />
        <ResumeCard
          badge="2003 - 2023"
          title="Full stack Developer"
          subTitle="Parfois"
          des="Development of internal tools created to enhance the business experience for users"
        />
      </div>
      <div className="w-full h-full hidden lgl:flex justify-center items-center">
        <span className="w-[1px] h-full bg-zinc-800 inline-flex"></span>
      </div>
      <div className="col-span-9 md:col-span-4">
        <ResumeTitle title="Education" icon={<GiGraduateCap />} />
        <ResumeCard
          badge="2004 - 2008"
          title="c# development"
          subTitle="Portugal"
          des="I embarked on my journey to learn C# to enhance my development expertise and build robust applications. This powerful language allows me to create dynamic solutions, deepening my understanding of software development and expanding my capabilities in both front-end and back-end technologies."
        />
        <ResumeCard
          badge="2019"
          title="Next & React"
          subTitle="Portugal"
          des="I began my journey to master Next.js and React to elevate my web development skills. With React, I can create dynamic user interfaces that deliver exceptional user experiences, while Next.js enhances my ability to build efficient, server-rendered applications. This combination empowers me to develop full-stack solutions that are both scalable and performant, allowing me to push the boundaries of what's possible in modern web development"
        />
        <ResumeCard
          badge="2021"
          title="SEO & API"
          subTitle="Portugal"
          des="I specialize in secure API development and SEO, creating robust applications that prioritize performance and data security. My expertise ensures seamless data interactions while optimizing for search engines to drive organic traffic and enhance visibility."
        />
      </div>
    </div>
  );
};

export default Education;
